// Game tuning singleton. Defaults match the original engine/spawner constants
// so the game still works offline / before BE config arrives. App boot fetches
// /v1/config and calls applyConfig() to overwrite live keys. Admin edits in
// the admin panel take effect on next page load (no hot reload).

export const tuning = {
  lives: 3,
  spawn_min_ms: 380,
  spawn_max_ms: 1050,
  drop_base_pxs: 180,
  drop_stage_mult: 0.22,
  bomb_chance: 0.06,
  golden_chance: 0.15,
  golden_fever_chance: 0.40,
  fever_duration_ms: 4500,
  milestones: [0, 5, 15, 30, 50, 70, 100, 150, 200, 250],
  stage_names: ['Tease', 'Flirt', 'Heat', 'Dance', 'Neon', 'Encore', 'VIP', 'Climax', 'Afterhour', 'Sunrise']
};

// applyConfig merges only known keys; ignores everything else (forward-compat
// when BE adds new keys we don't yet consume).
export function applyConfig(cfg) {
  if (!cfg || typeof cfg !== 'object') return;
  const map = {
    game_lives: 'lives',
    game_spawn_min_ms: 'spawn_min_ms',
    game_spawn_max_ms: 'spawn_max_ms',
    game_drop_base_pxs: 'drop_base_pxs',
    game_drop_stage_mult: 'drop_stage_mult',
    game_bomb_chance: 'bomb_chance',
    game_golden_chance: 'golden_chance',
    game_golden_fever_chance: 'golden_fever_chance',
    game_fever_duration_ms: 'fever_duration_ms',
    game_milestones: 'milestones',
    game_stage_names: 'stage_names'
  };
  for (const [src, dst] of Object.entries(map)) {
    if (cfg[src] !== undefined && cfg[src] !== null) {
      tuning[dst] = cfg[src];
    }
  }
}
